import React from 'react';
import i18n from 'i18next';
import classnames from 'classnames';
import AccountCircle from '@mui/icons-material/AccountCircle';
import CheckCircle from '@mui/icons-material/CheckCircle';
import Event from '@mui/icons-material/Event';

import { Card } from 'uikit/cards';
import { Tooltip } from 'uikit/tooltips';
import { Typo } from 'uikit/content';

import DefaultImage from '../images/defaultImage.svg';

import styles from '../styles/cardChallenge.module.scss';

const getDateFormat = (date) =>
  new Date(date).toLocaleDateString(document.documentElement.lang, {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    timeZone: 'UTC',
  });

const CardChallenge = ({
  challengeType,
  endsAt,
  image,
  name,
  size,
  startsAt,
  to,
  hasCompletedChallenge,
  hasJoinedChallenge,
  isExternalLink,
  onClick,
}) => (
  <Card className={styles.element} to={to} isExternalLink={isExternalLink} onClick={onClick}>
    <div className={styles.content}>
      {(hasJoinedChallenge || hasCompletedChallenge) && (
        <div className={styles.status}>
          <Tooltip content={hasCompletedChallenge ? i18n.t('completed') : i18n.t('joined')}>
            {hasCompletedChallenge ? (
              <CheckCircle sx={{ height: 18, width: 18 }} />
            ) : (
              <AccountCircle sx={{ height: 18, width: 18 }} />
            )}
          </Tooltip>
        </div>
      )}
      <div
        className={classnames(styles.image, {
          [styles.isLarge]: size === 'large',
        })}
      >
        {image ? (
          <img className={styles.imageSrc} src={image} alt="" />
        ) : (
          <DefaultImage className={styles.imageSrc} alt="" />
        )}
      </div>
      <div className={styles.inner}>
        <Typo color="secondary" element="span" variant="s01">
          {challengeType}
        </Typo>
        <Typo className={styles.title} element="span" variant="d01" weight="medium">
          {name}
        </Typo>
        {/*
          Switch this to the <CardMeta> component once we have
          updated the icon and type to the correct values
        */}
        <div className={styles.meta}>
          <Event className={styles.icon} sx={{ height: 18, width: 18 }} />
          <Typo color="secondary" element="span" variant="s02">
            {`${getDateFormat(startsAt)} - ${getDateFormat(endsAt)}`}
          </Typo>
        </div>
      </div>
    </div>
  </Card>
);

export default React.memo(CardChallenge);
